
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_uhoh6_105",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_uhoh6_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_uhoh6_1",
  "refresh": "awsui_refresh_1d2i7_uhoh6_128",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_uhoh6_1",
  "root": "awsui_root_1d2i7_uhoh6_161",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_uhoh6_1",
  "hidden": "awsui_hidden_1d2i7_uhoh6_248",
  "focus-lock": "awsui_focus-lock_1d2i7_uhoh6_252",
  "small": "awsui_small_1d2i7_uhoh6_270",
  "medium": "awsui_medium_1d2i7_uhoh6_273",
  "large": "awsui_large_1d2i7_uhoh6_276",
  "max": "awsui_max_1d2i7_uhoh6_279",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_uhoh6_279",
  "container": "awsui_container_1d2i7_uhoh6_284",
  "content": "awsui_content_1d2i7_uhoh6_325",
  "no-paddings": "awsui_no-paddings_1d2i7_uhoh6_328",
  "header": "awsui_header_1d2i7_uhoh6_332",
  "header--text": "awsui_header--text_1d2i7_uhoh6_339",
  "footer": "awsui_footer_1d2i7_uhoh6_343",
  "footer--stuck": "awsui_footer--stuck_1d2i7_uhoh6_351",
  "dismiss-control": "awsui_dismiss-control_1d2i7_uhoh6_360",
  "modal-open": "awsui_modal-open_1d2i7_uhoh6_364"
};
  